import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=4c4a986d&scoped=true"
import script from "./Downloads.vue?vue&type=script&lang=js"
export * from "./Downloads.vue?vue&type=script&lang=js"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=4c4a986d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a986d",
  null
  
)

export default component.exports